import type { CountryCode } from '@/types/locales'

// Countries where checkout is supported and we take payment, with the currency charged in each.

export const CHECKOUT_US = 'US'
export const CHECKOUT_GB = 'GB'
export const CHECKOUT_AU = 'AU'
export const CHECKOUT_NZ = 'NZ'
export const CHECKOUT_COUNTRIES = [
  CHECKOUT_US,
  CHECKOUT_GB,
  CHECKOUT_AU,
  CHECKOUT_NZ,
] as const satisfies readonly CountryCode[]
export type CheckoutCountry = (typeof CHECKOUT_COUNTRIES)[number]

export const CURRENCY_US = 'usd'
export const CURRENCY_GB = 'gbp'
export const CURRENCY_AU = 'aud'
export const CURRENCY_NZ = 'nzd'
export type CurrencyCode = typeof CURRENCY_US | typeof CURRENCY_GB | typeof CURRENCY_AU | typeof CURRENCY_NZ

export const COUNTRY_CURRENCY: Record<CheckoutCountry, CurrencyCode> = {
  [CHECKOUT_US]: CURRENCY_US,
  [CHECKOUT_GB]: CURRENCY_GB,
  [CHECKOUT_AU]: CURRENCY_AU,
  [CHECKOUT_NZ]: CURRENCY_NZ,
}

/**
 * Matches payment-service's `Market.paymentMethods`: the subscription it creates accepts only these (not Bacs,
 * SEPA). Klarna cannot settle `aud` or `nzd`.
 */
export const COUNTRY_PAYMENT_METHOD_TYPES: Record<CheckoutCountry, string[]> = {
  [CHECKOUT_US]: ['card', 'klarna'],
  [CHECKOUT_GB]: ['card', 'klarna'],
  [CHECKOUT_AU]: ['card'],
  [CHECKOUT_NZ]: ['card'],
}

export type CheckoutPath = 'intent' | 'session'
